import { Component, Input, forwardRef, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE, DateAdapter } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import * as _moment from 'moment';

const moment = _moment;

export const CUSTOM_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY',
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-datepicker-material',
  templateUrl: './app-datepicker-material.component.html',
  styleUrls: ['./app-datepicker-material.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppDatepickerMaterialComponent),
      multi: true
    },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }
  ]
})
export class AppDatepickerMaterialComponent implements ControlValueAccessor, OnChanges {
  @Input() placeholder = 'dd-mm-yyyy';
  @Input() disabled: boolean = false;

  @Input() minDate: any = null;
  @Input() maxDate: any = null;

  value: any = null;

  onChange = (_: any) => { };
  onTouched = () => { };

  writeValue(val: any): void {
    if (val) {
      const momentObj = moment(val);
      this.value = momentObj.isValid() ? momentObj : null;
    } else {
      this.value = null;
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onModelChange(value: any): void {
    if (moment.isMoment(value) && value.isValid()) {
      this.value = value;
      this.onChange({
        year: value.year(),
        month: value.month() + 1,
        day: value.date()
      });
    } else {
      this.value = null;
      this.onChange(null);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.minDate) {
      this.minDate = this.convertToMoment(changes.minDate.currentValue);
    }
    if (changes.maxDate) {
      this.maxDate = this.convertToMoment(changes.maxDate.currentValue);
    }
  }

  private convertToMoment(input: any): _moment.Moment | null {
    if (!input) return null;

    // Supports {year, month, day}, Date, or Moment
    if (input.year && input.month && input.day) {
      return moment({ year: input.year, month: input.month - 1, day: input.day });
    }
    const m = moment(input);
    return m.isValid() ? m : null;
  }
}
